"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ErrorMessageType = _interopRequireDefault(require("crm_ui/error/ErrorMessageType"));

var _QueryErrorStateMessage = _interopRequireDefault(require("crm_ui/messaging/QueryErrorStateMessage"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

function ProfileTimelineErrorMessage(_ref) {
  var errorMessageType = _ref.errorMessageType,
      objectType = _ref.objectType;
  return _react.default.createElement("div", {
    className: "p-y-2"
  }, _react.default.createElement(_QueryErrorStateMessage.default, {
    errorMessageType: errorMessageType,
    objectType: objectType
  }));
}

ProfileTimelineErrorMessage.propTypes = {
  errorMessageType: _ErrorMessageType.default,
  objectType: _ObjectTypesType.default
};
ProfileTimelineErrorMessage.displayName = 'ProfileTimelineErrorMessage';
var _default = ProfileTimelineErrorMessage;
exports.default = _default;
module.exports = exports.default;